import { Content } from '@prismicio/client';
import {
  IItem,
  ITitleLeafImageTextRow,
  TitleLeafImageTextRowProps,
} from './types';

export const mapTitleLeafImageTextRow = ({
  prismicContent,
}: {
  prismicContent: TitleLeafImageTextRowProps['slice'];
}): ITitleLeafImageTextRow => {
  const items: IItem[] = prismicContent.items.map(
    ({
      image: { url: image, alt },
      picture_on_right: hasPictureOnRight,
      text,
    }: Content.TitleLeafImageTextRowSliceDefaultItem) => {
      return {
        image: image as string,
        alt: alt as string,
        hasPictureOnRight,
        text,
      };
    },
  );
  const { title } = prismicContent.primary;

  const titleLeafImageTextRow: ITitleLeafImageTextRow = {
    title,
    items,
  };

  return titleLeafImageTextRow;
};
